<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage" id="titlepage">
<div class="ipadfp"><span aria-label="iii" epub:type="pagebreak" id="page_iii" role="doc-pagebreak" title="iii"><img alt="Miracles and Other Reasonable Things by Sarah Bessey, Howard Books" class="imagefp" src="e9781501155475/images/title.jpg"/></span></div></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?fb0df306